export default "__VITE_ASSET__Cl$eE6NY__"